const jarjestelmat = [
  {
    row: 'Materiaalivaihtoehdot',
    ranka: '[Sahatavara|Viilupuu|Liimapuu]',
    puulevy: '[CLT|Viilupuu]',
    hirsi: '[Lamelli|Painumaton]',
    pilari: '[Liimapuu|Viilupuu]'
  },
  {
    row: 'Rakenneperiaate',
    ranka: 'Levy, eriste+runko, levy, (tuulensuojavilla, verhous)',
    puulevy: '[Levy, kova eriste, levy, tuulensuojavilla, verhous | Massiiviset (eristeettömät) rakenteet]',
    hirsi: '[Lisäeristetty hirsirakenne | Massiiviset (eristeettömät) rakenteet]',
    pilari: 'Pilarit ja palkit'
  },
  {
    row: 'Näkyvät puupinnat',
    ranka: 'Panelointi, levytys',
    puulevy: 'CLT levyn voi jättää näkyviin\n' +
        'Myös viilupuu, jos pintaviilu valittu\n' +
        'CLT halkeilu (liimaustapa)\n' +
        'Kiinnikkeet, akustiikka, pintakäsittelyt \n' +
        'Ei ulkotiloissa',
    hirsi: 'Kiinnikkeet, akustiikka, pintakäsittely',
    pilari: 'Liitokset, suojaverhousvaatimukset'
  },
  {
    row: 'Optimi käyttöalue\n' +
        'Rakennusosat\n' +
        'Kerrosluku\n' +
        'Jännemitat',
    ranka: 'Seinä-, ala-, väli- ja yläpohjarakenteet\n' +
        'Kantavissa rakenteissa 1 - 4 (6)\n' +
        'Välipohjat liima- ja viilipuu (alle 7)\n' +
        'Ristikkorakenteet',
    puulevy: 'Seinä ja väli- ja yläpohjarakenteet\n' +
        'Kantavissa rakenteissa 1>\n' +
        'Välipohjien matalataajuuslattiat (alle 7)',
    hirsi: 'Kantavat ja ulkovaipan seinärakenteet\n' +
        'Kantavissa rakenteissa 1-4',
    pilari: 'Pilari-palkkirakenteet\n' +
        'Pystyrakenteet\n' +
        'Vaakarakenteet'
  },
  {
    row: 'Yhdistelmäkäyttö',
    ranka: 'Eri ratkaisuja voi käyttää myös yhdessä',
    puulevy: 'Eri ratkaisuja voi käyttää myös yhdessä',
    hirsi: 'Eri ratkaisuja voi käyttää myös yhdessä',
    pilari: 'Eri ratkaisuja voi käyttää myös yhdessä'
  },
  {
    row: 'Tuotantotavat',
    ranka: '[Paikalla|Tasoelementti|Tila-elementti]',
    puulevy: 'Levyjen CNC-työstö: [Varustelu rakennus-paikalla|Esivalmistus tehtaalla / Tila-elementti]',
    hirsi: 'Hirsien CNC-työstö: [Kokoaminen rakennuspaikalla]',
    pilari: 'Osien CNC työstö: [Liittäminen rakennuspaikalla]'
  },
  {
    row: 'Rakenteiden jäykistys',
    ranka: 'Levyjäykistys',
    puulevy: 'Levy itsessään jäykistää\n' +
        'Aukotus pienentää jäykistyskapasiteettia',
    hirsi: 'Hirsien vaarnaus',
    pilari: ''
  },
  {
    row: 'Rakennuksen jäykistys',
    ranka: 'Levyjäykistyksen periaate\n' +
        'Jäykistystornien käyttö\n' +
        'Ankkurointi ',
    puulevy: 'Levyjäykistyksen periaate\n' +
        'Jäykistystornien käyttö\n' +
        'Ankkurointi ',
    hirsi: 'Jäykistyksen periaate\n' +
        'Jäykistystornien käyttö\n' +
        'Ankkurointi ',
    pilari: 'Jäykistyksen periaate\n' +
        'Jäykistystornien käyttö\n' +
        'Mastojäykistys\n' +
        'Ankkurointi '
  },
  {
    row: 'Liitokset',
    ranka: 'US-AP, US-VP, US-YP, HVS-AP, HVS-VP, HVS-YP, VS-AP, VS-VP, VS-YP, US-US, US-HVS, US-VS\n' +
        'Naulat\n' +
        'Ruuvit\n' +
        'Kulma- ja naulalevyt, palkkikengät',
    puulevy: 'US-AP, US-VP, US-YP, HVS-AP, HVS-VP, HVS-YP, VS-AP, VS-VP, VS-YP, US-US, US-HVS, US-VS\n' +
        'Vinoruuvaus\n' +
        'Kulma- ja naulalevyt\n' +
        'X-Rad',
    hirsi: 'US-AP, US-VP, US-YP, HVS-AP, HVS-VP, HVS-YP, VS-AP, VS-VP, VS-YP, US-US, US-HVS, US-VS\n' +
        'Vaarnaus',
    pilari: 'Tappi-vaarna\n' +
        'Palkkikengät\n' +
        'Vinoruuvaus'
  },
  {
    row: 'Liitokset',
    ranka: 'Tarvittava massa\n' +
        'Kerroksellisuus\n' +
        'Eristeet\n' +
        'Tärinävaimennus',
    puulevy: 'Tarvittava massa\n' +
        'Kerroksellisuus\n' +
        'Eristeet\n' +
        'Tärinävaimennus',
    hirsi: 'Tarvittava massa\n' +
        'Kerroksellisuus\n' +
        'Eristeet\n' +
        'Tärinävaimennus',
    pilari: ''
  },
  {
    row: 'Talotekniikan lävistykset',
    ranka: 'Palokatkot',
    puulevy: 'Palokatkot',
    hirsi: 'Palokatkot',
    pilari: ''
  }
]

export default jarjestelmat



// WEBPACK FOOTER //
// ./src/data/jarjestelmat.js